import React from 'react';
import { defineMessage } from 'react-intl';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';


function getInterestRateTextFromCardInfo({
    purchaseInterest,
    cashAdvanceInterest,
    balanceTransferInterest,
    intl,
    options = {
        doBoldInterestRates: true,
    },
}) {
    return intl.formatMessage(defineMessage({
        id: 'cc.rt.cardFooter.interestRates',
        defaultMessage: `Purchase interest: <b>{purchaseInterest, select,
            null {N/A}
            other {{purchaseInterest, number, percent2}}
        }</b>{newline}Cash advance: <b>{cashAdvanceInterest, select,
            null {N/A}
            other {{cashAdvanceInterest, number, percent2}}
        }</b>{newline}Balance transfer: <b>{balanceTransferInterest, select,
            null {N/A}
            other {{balanceTransferInterest, number, percent2}}
        }</b>`,
    }), {
        ...DefaultIntlFormatValues,
        ...(options?.doBoldInterestRates
            ? undefined
            // eslint-disable-next-line react/jsx-one-expression-per-line
            : { b: str => <>{str}</> }
        ),
        purchaseInterest: purchaseInterest === null
            ? null
            : purchaseInterest / 100,
        cashAdvanceInterest: cashAdvanceInterest === null
            ? null
            : cashAdvanceInterest / 100,
        balanceTransferInterest: balanceTransferInterest === null
            ? null
            : balanceTransferInterest / 100,
    });
}


export default getInterestRateTextFromCardInfo;
